/*
 * Purpose: AutoBlocks compose page — inside AppShell
 * Last modified: 2026-06-28 | Agent
 * Completeness: 96
 */
import { PRODUCT_TERMS } from '@/lib/productTerms';
import { SetupBanner } from '@/components/setup/SetupBanner';
import { AutoBlocksComposer } from '@/components/AutoBlocksComposer';
import { ArtifactStateBadge } from '@/components/intent/ArtifactStateBadge';
import { useAutoBlocksStore } from '@/stores/autoBlocksStore';
import { PageMotion } from '@/components/motion/PageMotion';

export default function ComposePage() {
  const autopilot = useAutoBlocksStore((s) => s.autopilot);
  const artifactState = useAutoBlocksStore((s) => s.artifactState);
  const composeMode = useAutoBlocksStore((s) => s.composeMode);
  const phase = useAutoBlocksStore((s) => s.phase);
  const isAutopilotRunning = useAutoBlocksStore((s) => s.isAutopilotRunning);

  const subtitle = autopilot
    ? isAutopilotRunning
      ? 'Autopilot — planning and dry run in progress'
      : artifactState === 'flow'
        ? 'Flow saved — open Dashboard to monitor live runs'
        : 'Review plan — unlock vault, connect services, run live'
    : artifactState === 'flow'
      ? 'Your Flow is ready — open Mission to edit the map'
      : phase === 'confirm'
        ? 'Confirm interpretation — Express or Guided'
        : 'Now → Up next → History — your outcome stays pinned';

  return (
    <>
      <div className="shrink-0 border-b border-border/40 px-4 sm:px-6 py-3 bg-muted/20">
        <div className="max-w-5xl mx-auto flex items-center gap-2 flex-wrap min-w-0">
          <h1 className="ab-brand-wordmark text-foreground text-base sm:text-lg truncate">
            {PRODUCT_TERMS.autoBlockFlowComposer}
          </h1>
          <ArtifactStateBadge artifactState={artifactState} composeMode={composeMode} />
          <p className="text-xs text-muted-foreground w-full sm:w-auto sm:ml-auto truncate">{subtitle}</p>
        </div>
      </div>
      <SetupBanner />
      <main className="flex-1 overflow-auto p-4 sm:p-6">
        <PageMotion variant="body">
          <AutoBlocksComposer />
        </PageMotion>
      </main>
    </>
  );
}
